// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","shadow":"file-input_shadow__3RV-1","fileInput":"file-input_fileInput__4SGYF","input":"file-input_input__2RizD"};